import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { authActions } from '../store/reducers/authReducer';
import { RootState } from '../store/store';

const getPageTitle = (pathname: string) => {
    if (pathname.startsWith('/space/')) return 'Edit Space';
    if (pathname.startsWith('/map/')) return 'Edit Map';
    if (pathname.startsWith('/label/')) return 'Edit Label';
    if (pathname.startsWith('/feedback-question/')) return 'Edit Feedback Question';
    if (pathname.startsWith('/page/')) return 'Edit Info Page';
    if (pathname.startsWith('/treasure/')) return 'Edit Treasure Clue';
    if (pathname.startsWith('/selfie-mask/')) return 'Edit Selfie Mask';
    if (pathname.startsWith('/screen/')) return 'Edit Screen';
    if (pathname.startsWith('/location/')) return 'Edit Location';
    if (pathname.startsWith('/env-sound/')) return 'Edit Environment Sound';

    switch (pathname) {
        case '/dashboard': return 'Dashboard';
        case '/spaces': return 'Spaces';
        case '/maps': return 'Maps';
        case '/labels': return 'Labels';
        case '/feedback-question': return 'Feedback Questions';
        case '/pages': return 'Info Pages';
        case '/treasure': return 'Treasure Hunt';
        case '/models': return 'Models';
        case '/model': return 'Edit Model';
        case '/selfie-mask': return 'Selfie Masks';
        case '/user': return 'Users';
        case '/my-account': return 'My Account';
        case '/screen': return 'Screens';
        case '/locations': return 'Locations';
        case '/env-sounds': return 'Environment Sounds';
        default: return 'Heritage CMS';
    }
};

export default function Header({ onToggle }: { onToggle: () => void }) {

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const user = useSelector((state: RootState) => state.auth.user) as any;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        dispatch(authActions.logout());
        setAnchorEl(null);
        window.location.href = '/login';
    };

    return (
        <Box sx={{ width: '100%', borderBottom: '1px solid #e2e8f0' }}>
            <AppBar position="static" sx={{ bgcolor: 'white', boxShadow: 'none' }}>
                <Toolbar>
                    <IconButton
                        size="large"
                        edge="start"
                        aria-label="menu"
                        sx={{ mr: 2, color: '#1e293b' }}
                        onClick={onToggle}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1, color: '#1e293b', fontWeight: 700 }}>
                        {getPageTitle(location.pathname)}
                    </Typography>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        {/* Optional Quick Actions button could go here */}
                    </Box>
                </Toolbar>
            </AppBar>
        </Box>
    );
}
